import { GraphQLErrorCodes, PspRefusedCodes } from 'utils/errors/types';

/**
 * Extension key added to synthetic errors produced by the commit-order-test-error-modal link.
 * Used to identify these errors in logs.
 */
export const COMMIT_ORDER_TEST_ERROR_MODAL_EXTENSION_KEY = 'commitOrderTestErrorModal';

/**
 * All supported LaunchDarkly flag values for `commit-order-test-error-modal`.
 * Use these in the LD dashboard to trigger the corresponding error modal when committing an order.
 *
 * - PSP codes: Show the PSP-refused error modal (payment declined, insufficient funds, etc.).
 * - GraphQL codes: Show the generic commit-error modal for that code (cooling period, validation, etc.).
 * - Any other non-empty string: Show generic error modal with that message.
 */
export const COMMIT_ORDER_TEST_ERROR_MODAL_PSP_VALUES = Object.values(PspRefusedCodes) as string[];

export const COMMIT_ORDER_TEST_ERROR_MODAL_GQL_VALUES: GraphQLErrorCodes[] = [
  GraphQLErrorCodes.PAYMENTS_DECLINED_ERROR,
  GraphQLErrorCodes.PAYMENTS_DETAILS_ERROR,
  GraphQLErrorCodes.PAYMENTS_ERROR,
  GraphQLErrorCodes.PAYMENT_NOT_SUPPORTED,
  GraphQLErrorCodes.PAYMENTS_AVS_ERROR,
  GraphQLErrorCodes.COMMIT_ORDER_COOLING_PERIOD,
  GraphQLErrorCodes.PREPAID_METHOD_NOT_SUPPORTED_BY_STORE,
  GraphQLErrorCodes.GRAPHQL_VALIDATION_FAILED,
  GraphQLErrorCodes.TOO_MANY_REQUESTS,
];
